const slider = document.getElementById('slider');
const images = slider.querySelectorAll('img');
const dotsContainer = document.getElementById('dots');
let currentIndex = 0;
let autoSlide;

// Crear dots dinámicamente
images.forEach((_, idx) => {
  const dot = document.createElement('span');
  dot.addEventListener('click', () => goToSlide(idx));
  dotsContainer.appendChild(dot);
});
const dots = dotsContainer.querySelectorAll('span');

// Función para actualizar slider
function updateSlider() {
  const imageWidth = images[0].clientWidth; // ancho dinámico
  slider.style.transform = `translateX(-${currentIndex * imageWidth}px)`;
  dots.forEach(dot => dot.classList.remove('active'));
  if(dots[currentIndex]) dots[currentIndex].classList.add('active');
}

// Cambiar slide
function cambiarSlide(n){
  currentIndex += n;
  if(currentIndex<0) currentIndex=images.length-1;
  if(currentIndex>=images.length) currentIndex=0;
  updateSlider();
}

// Ir a slide específico
function goToSlide(idx){
  currentIndex = idx;
  updateSlider();
}

// Auto-slide solo en tablet/desktop (≥768px)
function startAutoSlide(){
  clearInterval(autoSlide);
  if(window.innerWidth>=768){
    autoSlide = setInterval(()=>{
      currentIndex++;
      if(currentIndex>=images.length) currentIndex=0;
      updateSlider();
    },5000);
  }
}

// Pausar al pasar mouse
slider.addEventListener('mouseenter',()=> clearInterval(autoSlide));
slider.addEventListener('mouseleave', startAutoSlide);

// Inicializar
window.addEventListener('resize', ()=>{
  updateSlider();
  startAutoSlide();
});

// Inicializar al cargar
updateSlider();
startAutoSlide();

function startAutoSlide(){
  clearInterval(autoSlide);
  // quitar restricción de width si quieres también en móviles
  autoSlide = setInterval(()=>{
      currentIndex++;
      if(currentIndex>=images.length) currentIndex=0;
      updateSlider();
  },5000);
}

let startX = 0;
slider.addEventListener('touchstart', e => {
  startX = e.touches[0].clientX;
  clearInterval(autoSlide);
});

slider.addEventListener('touchend', e => {
  const endX = e.changedTouches[0].clientX;
  if(endX - startX > 50) cambiarSlide(-1); // swipe derecha
  else if(startX - endX > 50) cambiarSlide(1); // swipe izquierda
  startAutoSlide();
});